var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30094 6.84996L6.94286 1C7.46837 1 7.97236 1.20544 8.34395 1.57114C8.71554 1.93683 8.9243 2.43282 8.9243 2.94999V5.54997H12.6626C12.8541 5.54784 13.0438 5.5867 13.2185 5.66386C13.3932 5.74103 13.5487 5.85465 13.6744 5.99685C13.8 6.13906 13.8928 6.30645 13.9462 6.48743C13.9995 6.66841 14.0123 6.85864 13.9836 7.04496L13.0721 12.8949C13.0243 13.2049 12.8643 13.4875 12.6216 13.6905C12.3789 13.8936 12.0697 14.0035 11.7512 13.9999H4.30094M4.30094 6.84996V13.9999M4.30094 6.84996H2.3195C1.96916 6.84996 1.63316 6.98693 1.38544 7.23072C1.13771 7.47452 0.998535 7.80518 0.998535 8.14995V12.6999C0.998535 13.0447 1.13771 13.3754 1.38544 13.6192C1.63316 13.863 1.96916 13.9999 2.3195 13.9999H4.30094",
    stroke: "#01C324",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedIcon);
export default __webpack_public_path__ + "static/media/liked-icon.90ac14a7640ba15f5fcfe554ad164c48.svg";
export { ForwardRef as ReactComponent };